import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { IoMdSend } from 'react-icons/io'
import dayjs from 'dayjs'
import AuthContext from 'context/AuthContext'
import relativeTime from 'dayjs/plugin/relativeTime'
import helpers from 'utils/helpers'
import InfiniteScroll from 'react-infinite-scroll-component'
import { preventMaxInput } from 'utils/validations'
import { useForm } from 'react-hook-form'
dayjs.extend(relativeTime)

const NoteView = ({ handleNoteView, selectedTask }) => {
  const { register, handleSubmit, clearErrors, setError, reset, setValue } =
    useForm({
      mode: 'onBlur',
      shouldFocusError: true
    })
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const [messageData, setMessageData] = useState('')
  const [messages, setMessages] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [hasNextPage, setHasNextPage] = useState(false)

  const onSubmit = e => {
    // e.preventDefault()
    let payload = {
      taskId: selectedTask?._id,
      message: messageData?.trim()
    }
  }

  useEffect(() => {
    let payload = { taskId: selectedTask?._id, page, limit: pageSize }
  }, [])

  const loadMoreData = () => {
    const pageCount = page + 1
    setPage(pageCount)
    let payload = {
      taskId: selectedTask?._id,
      page: pageCount,
      limit: pageSize
    }
  }

  const selectCategory = e => {
    if (e.target.value) {
      setMessageData(e.target.value)
      clearErrors('message')
    } else {
      setMessageData('')
      setError('message', {
        type: 'validation',
        message: 'Please enter message.'
      })
    }
  }

  return (
    <>
      <div className='justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[540px] max-h-[90vh] overflow-y-auto	'>
            <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
              <h3 className='text-xl font-semibold'>{t('NOTES')}</h3>
              <button
                className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                onClick={() => handleNoteView(false)}
              >
                <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                  ×
                </span>
              </button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                id='scrollableDiv'
                className='bg-[#f1f1f1] p-5'
                style={{
                  height: 500,
                  overflow: 'auto',
                  display: 'flex',
                  flexDirection: 'column-reverse'
                }}
              >
                <InfiniteScroll
                  dataLength={messages?.length}
                  next={loadMoreData}
                  style={{ display: 'flex', flexDirection: 'column-reverse' }}
                  inverse={true}
                  hasMore={hasNextPage}
                  scrollableTarget='scrollableDiv'
                >
                  {messages &&
                    messages?.length > 0 &&
                    messages
                      ?.sort(
                        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                      )
                      ?.map((item, index) => {
                        const date = dayjs(item?.createdAt)
                        const formattedDate = date?.fromNow()
                        return (
                          <>
                            {helpers?.ternaryCondition(
                              item?.type === 'heading',
                              <div className='text-sm font-bold text-center p-2 '>
                                {formattedDate}
                              </div>,
                              <div className='mb-3'>
                                {item?.userId !== user?._id ? (
                                  <div className='w-1/2 text-left'>
                                    <span className='text-dark mb-1 block'>
                                      {item?.employee?.name}
                                    </span>
                                    <div className='bg-white mb-2 me-auto py-3 px-4 rounded-3xl'>
                                      <p className='mb-0 text-sm'>
                                        {item?.message}
                                      </p>
                                    </div>
                                    <span className='text-xs text-gray-500 block'>
                                      {dayjs(item?.createdAt).format('h:mm A')}
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    key={index}
                                    className='mb-3 w-1/2 ms-auto'
                                  >
                                    <div className='bg-[#dfdfff] mb-2 me-auto py-3 px-4 rounded-3xl'>
                                      <p className='mb-1 text-sm'>
                                        {item?.message}
                                      </p>
                                    </div>
                                    <span className='text-xs text-gray-500 block text-end'>
                                      {dayjs(item?.createdAt).format('h:mm A')}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )
                      })}
                </InfiniteScroll>
              </div>

              <div className='relative py-4 px-5 flex-auto bg-[#2e3191]'>
                <div className='grid'></div>
                <div className=''>
                  <div className='relative z-0 w-full flex'>
                    <input
                      className={`block py-3 px-3 w-full text-sm text-black bg-white border-2 rounded-3xl appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer`}
                      name='message'
                      placeholder='Message'
                      type='text'
                      value={messageData}
                      {...register('message', {
                        required: 'Please enter message.'
                      })}
                      onInput={e => preventMaxInput(e)}
                      onChange={e => {
                        selectCategory(e)

                        setValue('message', e?.target?.value)
                      }}
                    />
                    <button
                      type='submit'
                      className='ms-4 text-2xl bg-[#00007f] p-2 rounded-full text-white text-center w-[50px] h-[50px] flex items-center justify-center'
                    >
                      <IoMdSend />
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default NoteView
